import { lazy, Suspense } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './guards/AuthGuard';
import { useAuth } from './contexts/AuthContext';

const MyProfileRedirect = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/profile/${user.id}`} replace />;
};

const HomePage = lazy(() => import('./pages/HomePage'));
const VideoPage = lazy(() => import('./pages/VideoPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const UploadPage = lazy(() => import('./pages/UploadPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const PlaylistPage = lazy(() => import('./pages/PlaylistPage'));
const EmbedPage = lazy(() => import('./pages/EmbedPage'));

const PageSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div style={{
      width: 40,
      height: 40,
      border: '4px solid var(--border)',
      borderTop: '4px solid var(--primary)',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
  </div>
);

const App = () => {
  return (
    <AuthProvider>
      <Suspense fallback={<PageSpinner />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/video/:code" element={<VideoPage />} />
          {/* Встраиваемый плеер для сторонних сайтов — без шапки и меню */}
          <Route path="/embed/:code" element={<EmbedPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/upload" element={<AuthGuard><UploadPage /></AuthGuard>} />
          {/* /profile → редирект на свой профиль */}
          <Route path="/profile" element={<AuthGuard><MyProfileRedirect /></AuthGuard>} />
          <Route path="/profile/:userId" element={<ProfilePage />} />
          <Route path="/playlist/:id" element={<PlaylistPage />} />
          <Route path="/settings" element={<AuthGuard><SettingsPage /></AuthGuard>} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
};

export default App;
